import { createContext, useContext } from 'react';

import { SIDE_MSG_DOCK_MODE } from '#/utils/userSideMsgPrefsStorage';

export const SideMsgDockContext = createContext({
  enableDockModes: false,
  mode: SIDE_MSG_DOCK_MODE.PINNED,
  floatingCollapsed: false,
  toggleMode: () => {},
  collapseFloating: () => {},
  expandFloating: () => {},
});

export function useSideMsgDock() {
  return useContext(SideMsgDockContext);
}
